import './map.scss'

import Swiper, { Scrollbar } from 'swiper'

const selectors = {
  container: '[data-map]',
  mapInteractive: '[data-map-interactive]',
  mapInteractiveItem: '[data-map-interactive-code]',
  mapImages: '[data-map-images]',
  region: '[data-map-region]',
  countries: '[data-map-countries]',
  country: '[data-map-country-code]',

  active: 'active',
  hidden: 'hidden',
}

const initMap = (container) => {
  const interactiveItems = container.querySelectorAll(selectors.mapInteractiveItem)
  const countries = [...container.querySelectorAll(selectors.country)].reduce(
    (acc, cur) => [
      ...acc,
      {
        code: cur.dataset.mapCountryCode,
        region: cur.dataset.mapCountryRegion,
        node: cur,
      },
    ],
    []
  )
  const tabs = [...container.querySelectorAll(selectors.region)].reduce(
    (acc, cur) => [
      ...acc,
      {
        region: cur.dataset.mapRegion,
        node: cur,
      },
    ],
    []
  )

  const imagesSwiper = new Swiper(container.querySelector(selectors.mapImages), {
    enabled: true,
    slidesPerView: 1,
    spaceBetween: 8,

    on: {
      slideChangeTransitionEnd: ({ activeIndex }) => tabs[activeIndex].node.click(),
    },

    breakpoints: {
      1024: {
        enabled: false,
      },
    },
  })

  const countriesSwiper = new Swiper(container.querySelector(selectors.countries), {
    modules: [Scrollbar],

    slidesPerView: 2,
    spaceBetween: 8,

    scrollbar: {
      el: container.querySelector('[data-map-countries-scrollbar]'),
      draggable: true,
    },

    breakpoints: {
      1024: {
        slidesPerView: 6,
      },
    },
  })

  interactiveItems?.forEach((item) =>
    item.addEventListener('click', () => {
      const code = item.dataset.mapInteractiveCode

      countries.find((country) => country.code.toLowerCase() === code.toLowerCase())?.node.firstElementChild.click()
    })
  )

  tabs?.forEach((tab, activeIndex) =>
    tab.node.addEventListener('click', () => {
      const region = tab.node.dataset.mapRegion
      const isActive = tab.node.classList.contains(selectors.active)

      if (activeIndex === 0) {
        tabs.forEach((tab) => tab.node.classList.remove(selectors.active))
        countries.forEach((country) => country.node.classList.remove(selectors.hidden))
      } else {
        tabs.forEach((tab) => tab.node.classList[region.includes(tab.region) ? (!isActive ? 'add' : 'remove') : 'remove'](selectors.active))
        countries.forEach((country) => country.node.classList[!region.includes(country.region) ? (!isActive ? 'add' : 'remove') : 'remove'](selectors.hidden))

        const isTabActive = tabs.some(({ node }) => node.classList.contains(selectors.active))

        imagesSwiper.slideTo(isTabActive ? activeIndex : 0, 300, false)
      }

      countriesSwiper.update()
    })
  )
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const containers = document.querySelectorAll(selectors.container)

    containers?.forEach(initMap)
  },
  { once: true }
)
